import React from 'react';

export const NoDataFound = () => {
  return (
    <section className='mt-4 text-center text-lg text-purple-600'>
      No Data Found
    </section>
  );
};
